module.exports = __webpack_public_path__ + "img/privilege_2_img2.6583b585.png";